<template>
  <v-stepper-content step="1">
    <h3>Paso 1</h3>
    <p>Aquí va el contenido del paso 1.</p>
    <v-btn color="primary" @click="goNext">Siguiente</v-btn>
  </v-stepper-content>
</template>

<script>
export default {
  props: ["goNext"],
};
</script>
